export const filterConstants = {
    FILTER_ACTION: 'FILTER_ACTION'
}
